(function () {
  const STORAGE_PREFIX = 'rosia-reviews-';

  function starsHtml(rating) {
    let html = '';
    for (let i = 1; i <= 5; i++) {
      html += `<span class="rosia-star${i <= rating ? ' is-filled' : ''}">★</span>`;
    }
    return html;
  }

  function getStorageKey(productId) {
    return `${STORAGE_PREFIX}${productId}`;
  }

  function loadStoredReviews(productId) {
    try {
      const raw = localStorage.getItem(getStorageKey(productId));
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveStoredReviews(productId, reviews) {
    try {
      localStorage.setItem(getStorageKey(productId), JSON.stringify(reviews));
    } catch (e) {
      /* ignore quota */
    }
  }

  function calcStats(reviews) {
    if (!reviews.length) return { avg: 0, counts: [0, 0, 0, 0, 0] };
    const counts = [0, 0, 0, 0, 0];
    let total = 0;
    reviews.forEach((r) => {
      const rating = Math.min(5, Math.max(1, Number(r.rating) || 5));
      total += rating;
      counts[rating - 1] += 1;
    });
    return { avg: total / reviews.length, counts };
  }

  function renderReviewItem(review) {
    const author = review.anonymous ? 'Anonymous' : review.author || 'Anonymous';
    const photo = review.photo
      ? `<img class="rosia-review-item__photo" src="${review.photo}" alt="" width="80" height="80" loading="lazy">`
      : '';
    const title = review.title ? `<h3 class="rosia-review-item__title">${escapeHtml(review.title)}</h3>` : '';
    const verified = '<span class="rosia-review-item__badge">Verified</span>';

    return `
      <article class="rosia-review-item" data-review-item data-rating="${review.rating}" data-date="${review.date || ''}">
        <div class="rosia-review-item__stars" aria-label="${review.rating} stars">${starsHtml(review.rating)}</div>
        <div class="rosia-review-item__meta">
          <span class="rosia-review-item__avatar" aria-hidden="true">👤</span>
          <span class="rosia-review-item__author">${escapeHtml(author)}</span>
          ${verified}
        </div>
        ${title}
        <p class="rosia-review-item__body">${escapeHtml(review.body || '')}</p>
        ${photo}
      </article>
    `;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function updateSummary(section, reviews) {
    const { avg, counts } = calcStats(reviews);
    const count = reviews.length;

    const avgStars = section.querySelector('[data-reviews-avg-stars]');
    const avgScore = section.querySelector('[data-reviews-avg-score]');
    const countEl = section.querySelector('[data-reviews-count]');
    const countText = section.querySelector('[data-reviews-count-text]');
    const empty = section.querySelector('[data-reviews-empty]');

    if (avgStars) avgStars.innerHTML = starsHtml(Math.round(avg));
    if (avgScore) avgScore.textContent = count ? `${avg.toFixed(2)} out of 5` : '0.00 out of 5';
    if (countEl) countEl.textContent = String(count);
    if (countText) {
      countText.innerHTML = `Based on <span data-reviews-count>${count}</span> review${count === 1 ? '' : 's'} <span class="rosia-product-reviews__verified" aria-label="Verified reviews">✓</span>`;
    }
    if (empty) empty.hidden = count > 0;

    section.querySelectorAll('[data-bar-star]').forEach((row) => {
      const star = Number(row.dataset.barStar);
      const fill = row.querySelector('[data-bar-fill]');
      const num = row.querySelector('[data-bar-count]');
      const starCount = counts[star - 1] || 0;
      const pct = count ? (starCount / count) * 100 : 0;
      if (fill) fill.style.width = `${pct}%`;
      if (num) num.textContent = String(starCount);
    });
  }

  function sortReviews(reviews, sortBy) {
    const sorted = [...reviews];
    if (sortBy === 'highest') {
      sorted.sort((a, b) => Number(b.rating) - Number(a.rating));
    } else if (sortBy === 'lowest') {
      sorted.sort((a, b) => Number(a.rating) - Number(b.rating));
    } else {
      sorted.sort((a, b) => String(b.date || '').localeCompare(String(a.date || '')));
    }
    return sorted;
  }

  function renderList(section, reviews, sortBy) {
    const list = section.querySelector('[data-reviews-list]');
    if (!list) return;

    const empty = list.querySelector('[data-reviews-empty]');
    const sorted = sortReviews(reviews, sortBy);

    list.querySelectorAll('[data-review-item]').forEach((el) => el.remove());

    sorted.forEach((review) => {
      list.insertAdjacentHTML('beforeend', renderReviewItem(review));
    });

    if (empty) {
      list.insertBefore(empty, list.firstChild);
      empty.hidden = sorted.length > 0;
    }
  }

  function notifyMerchant(email, productTitle, rating, body, name) {
    const form = document.getElementById('RosiaReviewContactForm');
    if (!form) return;
    const emailField = form.querySelector('[data-review-contact-email]');
    const bodyField = form.querySelector('[data-review-contact-body]');
    if (emailField) emailField.value = email;
    if (bodyField) {
      bodyField.value = `New product review submission\n\nProduct: ${productTitle}\nRating: ${rating}/5\nName: ${name}\n\nReview:\n${body}`;
    }
    fetch(form.action, { method: 'POST', body: new FormData(form) }).catch(() => {});
  }

  function initReviewsSection(section) {
    const productId = section.dataset.productId;
    const productTitle = section.dataset.productTitle || 'Product';
    let reviews = loadStoredReviews(productId);
    const sortSelect = section.querySelector('[data-reviews-sort]');

    function refresh() {
      updateSummary(section, reviews);
      renderList(section, reviews, sortSelect ? sortSelect.value : 'recent');
    }

    refresh();

    if (sortSelect) {
      sortSelect.addEventListener('change', () => refresh());
    }

    return {
      addReview(review) {
        reviews = [review, ...reviews];
        const stored = loadStoredReviews(productId);
        stored.unshift(review);
        saveStoredReviews(productId, stored);
        refresh();
      },
      productId,
      productTitle,
    };
  }

  function initReviewModal(api) {
    const modal = document.querySelector('[data-rosia-review-modal]');
    if (!modal || !api) return;

    const steps = Array.from(modal.querySelectorAll('[data-review-step]'));
    const starBtns = modal.querySelectorAll('[data-star-value]');
    const starsDisplay = modal.querySelector('[data-review-stars-display]');
    const bodyInput = modal.querySelector('[data-review-body]');
    const emailInput = modal.querySelector('[data-review-email]');
    const nameInput = modal.querySelector('[data-review-name]');
    const anonInput = modal.querySelector('[data-review-anonymous]');
    const photoInput = modal.querySelector('[data-review-photo]');
    const photoPreview = modal.querySelector('[data-review-photo-preview]');
    const photoImg = modal.querySelector('[data-review-photo-img]');
    const uploadTrigger = modal.querySelector('[data-review-upload-trigger]');
    const photoRemove = modal.querySelector('[data-review-photo-remove]');

    let step = 1;
    let rating = 0;
    let photoData = null;

    function showStep(n) {
      step = n;
      steps.forEach((s) => {
        const active = Number(s.dataset.reviewStep) === n;
        s.classList.toggle('is-active', active);
        s.hidden = !active;
      });
    }

    function openModal() {
      rating = 0;
      photoData = null;
      if (bodyInput) bodyInput.value = '';
      if (emailInput) emailInput.value = '';
      if (nameInput) nameInput.value = '';
      if (anonInput) anonInput.checked = false;
      if (photoInput) photoInput.value = '';
      if (photoPreview) photoPreview.hidden = true;
      if (uploadTrigger) uploadTrigger.hidden = false;
      starBtns.forEach((b) => b.classList.remove('is-active'));
      const firstNext = modal.querySelector('[data-review-step="1"] [data-review-next]');
      if (firstNext) firstNext.disabled = true;
      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      showStep(1);
    }

    function closeModal() {
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      if (step === 5) {
        const section = document.querySelector('[data-rosia-reviews-section]');
        if (section) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function setRating(val) {
      rating = val;
      starBtns.forEach((b) => {
        b.classList.toggle('is-active', Number(b.dataset.starValue) <= val);
      });
      if (starsDisplay) starsDisplay.innerHTML = starsHtml(val);
      const firstNext = modal.querySelector('[data-review-step="1"] [data-review-next]');
      if (firstNext) firstNext.disabled = val < 1;
    }

    document.querySelectorAll('[data-rosia-review-open]').forEach((btn) => {
      btn.addEventListener('click', openModal);
    });

    modal.querySelectorAll('[data-rosia-review-close]').forEach((btn) => {
      btn.addEventListener('click', closeModal);
    });

    starBtns.forEach((btn) => {
      btn.addEventListener('click', () => setRating(Number(btn.dataset.starValue)));
    });

    function goNext(btn) {
      if (step === 2 && bodyInput && !bodyInput.value.trim()) {
        bodyInput.focus();
        return;
      }
      if (step === 3) {
        if (!emailInput?.value.trim() || !nameInput?.value.trim()) {
          if (!emailInput?.value.trim()) emailInput?.focus();
          else nameInput?.focus();
          return;
        }
      }
      if (step === 4 || btn?.hasAttribute('data-review-submit')) {
        submitReview();
        return;
      }
      if (step < 5) showStep(step + 1);
    }

    modal.querySelectorAll('[data-review-next], [data-review-submit]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goNext(btn);
      });
    });

    modal.querySelectorAll('[data-review-back]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (step > 1) showStep(step - 1);
      });
    });

    if (uploadTrigger && photoInput) {
      uploadTrigger.addEventListener('click', () => photoInput.click());
      photoInput.addEventListener('change', () => {
        const file = photoInput.files?.[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => {
          photoData = reader.result;
          if (photoImg) photoImg.src = photoData;
          if (photoPreview) photoPreview.hidden = false;
          uploadTrigger.hidden = true;
        };
        reader.readAsDataURL(file);
      });
    }

    if (photoRemove) {
      photoRemove.addEventListener('click', () => {
        photoData = null;
        if (photoInput) photoInput.value = '';
        if (photoPreview) photoPreview.hidden = true;
        if (uploadTrigger) uploadTrigger.hidden = false;
      });
    }

    function submitReview() {
      if (!rating || rating < 1) {
        showStep(1);
        return;
      }
      if (!bodyInput?.value.trim()) {
        showStep(2);
        bodyInput?.focus();
        return;
      }

      const review = {
        id: `local-${Date.now()}`,
        rating,
        author: nameInput?.value.trim() || 'Anonymous',
        anonymous: anonInput?.checked || false,
        body: bodyInput.value.trim(),
        title: '',
        verified: true,
        date: new Date().toISOString().slice(0, 10),
        photo: photoData,
      };

      try {
        api.addReview(review);
      } catch (err) {
        /* still show thank you */
      }

      if (emailInput?.value) {
        notifyMerchant(
          emailInput.value,
          api.productTitle,
          rating,
          review.body,
          review.anonymous ? 'Anonymous' : review.author
        );
      }

      showStep(5);

      const section = document.querySelector('[data-rosia-reviews-section]');
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('[data-rosia-reviews-section]');
    if (!section) return;
    const api = initReviewsSection(section);
    initReviewModal(api);
  });
})();
